var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.categories, function(category) {
      return _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass:
                "custom-categories-table-row custom-data-row modal-categories"
            },
            [
              _c("div", { staticClass: "custom-categories-table-label" }, [
                _vm._v(_vm._s(category.name))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "custom-categories-table-label" }, [
                Object.keys(category.subcategories).length === 0 ||
                _vm.canChooseAny
                  ? _c(
                      "div",
                      {
                        staticClass: "buttons-group-collection field-edit",
                        staticStyle: { "text-align": "center" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "table-svg-button",
                            on: {
                              click: function($event) {
                                _vm.selectCategory(
                                  _vm.getHierarchy(category.id)
                                )
                              }
                            }
                          },
                          [_c("SVGPlus", { attrs: { width: 20, height: 20 } })],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c("ProductCategoriesRecursive", {
            staticStyle: {
              "margin-left": "15px",
              "border-left": "2px solid #c5c5c5"
            },
            attrs: {
              canChooseAny: _vm.canChooseAny,
              parents: _vm.getHierarchy(category.id),
              categories: category.subcategories
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }